export default [
  {value: '1', label: 'Alink'},
  {value: '2', label: '透传'}
]
